import React from 'react';
import { useTranslation } from 'react-i18next';
import { useChatStore } from '@modules/chat/store/chatStore';
import { Button } from '@common/components/button';
import { Icon } from '@common/components/icon';
import Tabs from '@common/components/tabs';
import MediaList from '@modules/chat/components/media-list/media-list';
import DocsList from '@modules/chat/components/docs-list/docs-list';

const ChatFiles = () => {
  const { t } = useTranslation();
  const {
    setOpenChatFilesSidebar,
  } = useChatStore();

  return (
    <div
      className={`
        tw-flex-none tw-w-[360px] tw-h-[calc(100vh-75px)] tw-bg-white
        tw-sticky tw-top-[72px] tw-z-[1] tw-overflow-y-hidden
        tw-border-l tw-border-background tw-border-solid tw-border-t-0
      `}
    >
      <div className="tw-px-6 tw-pt-4">
        <Button
          onClick={() => setOpenChatFilesSidebar(false)}
          size="small" type="primary" className="custom-blue-button tw-pt-[20px]"
        >
          <Icon type="arrow_left" />
        </Button>
      </div>
      <Tabs
        variant="full_width"
      >
        <Tabs.Item title={t('chat:conversation_files_media')}>
          <MediaList />
        </Tabs.Item>
        <Tabs.Item title={t('chat:conversation_files_docs')}>
          <div className="tw-pt-4 tw-pl-4 tw-pr-4">
            <DocsList />
          </div>
        </Tabs.Item>
      </Tabs>
    </div>
  );
};

export default React.memo(ChatFiles);
